module.exports = __webpack_public_path__ + "img/icons8-mazda.ae6f8697.svg";